"use strict";
var Any = (function () {
    function Any() {
    }
    return Any;
}());
exports.Any = Any;
//# sourceMappingURL=/Users/andreas/Documents/Git/git.appvision.ch/unibasel/json2typescript/src/json2typescript/any.js.map